import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, DeployedYear, DropdownMonthList, DropdownNumberOfCustomerList, EmptyString, InsertDateFormat } from "utils/Constant";
import { ApiGetCustomerRankStatistic, ApiGetDailyTransactionStatistic, ApiGetTransactionStatistic } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import Dropdown from "components/Input/Dropdown";
import { money } from "utils/helpers";
import moment from "moment";
import SalesChart from "components/Charts/SalesChart";
import ProfitChart from "components/Charts/ProfitChart";
import CustomerRankChart from "components/Charts/CustomerRankChart";
import DailyTransactionChart from "components/Charts/DailyTransactionChart";

export default function StatisticReport(){
    let navigate = useNavigate()

    const {fetch: getTransactionStatictic } = useFetch(ApiGetTransactionStatistic)
    const {fetch: getCustomerRank } = useFetch(ApiGetCustomerRankStatistic)
    const {fetch: getDailyTransactionStatistic } = useFetch(ApiGetDailyTransactionStatistic)

    const [year, setYear] = useState(moment(new Date()).format("yyyy"))
    const [customerRankYear, setCustomerRankYear] = useState(moment(new Date()).format("yyyy"))
    const [customerRankMonth, setCustomerRankMonth] = useState(moment(new Date()).format("M"))
    const [yearOptions, setYearOptions] = useState([])
    const [numberOfCustomer, setNumberOfCustomer] = useState(DropdownNumberOfCustomerList[0].value)
    const [salesData, setSalesData] = useState([
        {monthCode: "1", month: "January", sales: 0, profit: 0},
        {monthCode: "2", month: "February", sales: 0, profit: 0},
        {monthCode: "3", month: "March", sales: 0, profit: 0},
        {monthCode: "4", month: "April", sales: 0, profit: 0},
        {monthCode: "5", month: "May", sales: 0, profit: 0},
        {monthCode: "6", month: "June", sales: 0, profit: 0},
        {monthCode: "7", month: "July", sales: 0, profit: 0},
        {monthCode: "8", month: "August", sales: 0, profit: 0},
        {monthCode: "9", month: "September", sales: 0, profit: 0},
        {monthCode: "10", month: "October", sales: 0, profit: 0},
        {monthCode: "11", month: "November", sales: 0, profit: 0},
        {monthCode: "12", month: "December", sales: 0, profit: 0},
    ])
    const [customerRankData, setCustomerRankData] = useState([])
    const [customerRankSortByOptions, setCustomerRankSortByOptions] = useState([
        {label: "Sales", value: "1"},
        {label: "Profit", value: "2"}
    ])
    const [customerRankSortBy, setCustomerRankSortBy] = useState(customerRankSortByOptions[0].value)
    const [dailyTransactionMonth, setDailyTransactionMonth] = useState(moment(new Date()).format("M"))
    const [dailyTransactionYear, setDailyTransactionYear] = useState(moment(new Date()).format("yyyy"))
    const [dailyTransactionData, setDailyTransactionData] = useState([])
    
    const yearChange = (e) => {
        setYear(e.value)
    }
    const customerRankYearChange = (e) => {
        setCustomerRankYear(e.value)
    }
    const customerRankMonthChange = (e) => {
        setCustomerRankMonth(e.value)
    } 
    const numberOfCustomerChange = (e) => {
        setNumberOfCustomer(e.value)
    } 
    const customerRankSortByChange = (e) => {
        setCustomerRankSortBy(e.value)
    } 
    const getYearOptions = () => {
        let startYear = parseInt(DeployedYear)
        let thisYear = parseInt(moment(new Date()).format("yyyy"))

        let tempArray = []
        for (let i = startYear; i <= thisYear; i++){
            tempArray.push( {label: String(i), value: String(i)} )
        }

        setYearOptions(tempArray)
    }
    const dailyTransactionMonthChange = (e) => {
        setDailyTransactionMonth(e.value)
    }
    const dailyTransactionYearChange = (e) => {
        setDailyTransactionYear(e.value)
    }

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState({isOpen: false})
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    useEffect(() => {
        getYearOptions()
    },[])

    useEffect(() => {
        setLoading({isOpen: true})

        fGetTransactionStatistic().then(() => {
            setLoading({isOpen: false})
        })
    },[year])

    useEffect(() => {
        setLoading({isOpen: true})

        fGetCustomerRankStatistic().then(() => {
            setLoading({isOpen: false})
        })
    },[numberOfCustomer, customerRankYear, customerRankMonth, customerRankSortBy])

    useEffect(() => {
        setLoading({isOpen: true})

        fGetDailyTransactionStatistic().then(() => {
            setLoading({isOpen: false})
        })
    },[dailyTransactionMonth, dailyTransactionYear])

    // Function Api Call
    async function fGetTransactionStatistic(){
        await getTransactionStatictic({
            data: {
                accYear: year
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let data = response.data

                for (let i = 0; i < data.length; i++){
                    for (let j = 0; j < salesData.length; j++){
                        if (salesData[j].monthCode === data[i].month){
                            salesData[j].sales = data[i].sales
                            salesData[j].profit = data[i].profit
                        }
                    }
                    
                }
                
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fGetCustomerRankStatistic(){
        await getCustomerRank({
            data: {
                accYear: customerRankYear,
                accMonth: customerRankMonth,
                numberOfCustomer: numberOfCustomer,
                sortBy: customerRankSortBy
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let data = response.data

                setCustomerRankData(data)
                // for (let i = 0; i < data.length; i++){
                //     for (let j = 0; j < salesData.length; j++){
                //         if (salesData[j].monthCode === data[i].month){
                //             salesData[j].sales = data[i].sales
                //             salesData[j].profit = data[i].profit
                //         }
                //     }
                    
                // }
                
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fGetDailyTransactionStatistic(){
        await getDailyTransactionStatistic({
            data: {
                accYear: dailyTransactionYear,
                accMonth: dailyTransactionMonth
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let data = response.data

                setDailyTransactionData(data)                
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    return(
        <div className="flex flex-col gap-2">
            <div >
                <span className="font-semibold text-2xl">Statistic Report</span>
            </div>
            <hr />

            <div className="flex flex-col gap-5 justify-between mt-5 ">
                <div className="flex flex-col gap-2 sm:gap-4 w-full flex-wrap bg-white p-6 border rounded-lg">
                    <div className="">
                        <span className="font-semibold text-2xl tracking-wide">Annual Data</span>
                    </div>

                    <div className="flex items-center gap-4">
                        <span>Year</span>
                        <Dropdown className="w-24" options={yearOptions} value={year} onChange={yearChange} />
                    </div>

                    <div className="mt-5">
                        <div className="mb-5">
                            <span className="font-semibold text-2xl tracking-wide mb-5">Sales</span>
                        </div>
                        
                        <SalesChart data={salesData} />
                    </div>

                    <div className="mt-10">
                        <div className="mb-5">
                            <span className="font-semibold text-2xl tracking-wide">Profit</span>
                        </div>
                        
                        <ProfitChart data={salesData} />
                    </div>
                </div>

                <div className="mt-5 bg-white p-6 border rounded-lg">
                    <div className="mb-5">
                        <span className="font-semibold text-2xl tracking-wide">Daily Transaction</span>
                    </div>

                    <div className="mt-4 mb-8 flex items-center gap-4">
                        <div className="">
                            <span>Periode</span>
                        </div>
                        <Dropdown className="w-32" options={DropdownMonthList} value={dailyTransactionMonth} onChange={dailyTransactionMonthChange} />
                        <Dropdown className="w-24" options={yearOptions} value={dailyTransactionYear} onChange={dailyTransactionYearChange} />
                    </div>
                    
                    <DailyTransactionChart data={dailyTransactionData} />
                </div>

                <div className="mt-5 mb-10 bg-white p-6 border rounded-lg">
                    <div className="mb-5">
                        <span className="font-semibold text-2xl tracking-wide">Customer Ranking</span>
                    </div>
                    
                    <div className="flex items-center gap-4">
                        <span>Periode</span>
                        <Dropdown className="w-32" options={DropdownMonthList} value={customerRankMonth} onChange={customerRankMonthChange} />
                        <Dropdown className="w-24" options={yearOptions} value={customerRankYear} onChange={customerRankYearChange} />
                    </div>

                    <div className="mt-5 flex items-center gap-4">
                        <span>Show</span>
                        <Dropdown className="w-24" options={DropdownNumberOfCustomerList} value={numberOfCustomer} onChange={numberOfCustomerChange} />
                    </div>
                    
                    <div className="mt-5 flex items-center gap-4">
                        <span>Sort By</span>
                        <Dropdown className="w-24" options={customerRankSortByOptions} value={customerRankSortBy} onChange={customerRankSortByChange} />
                    </div>

                    <CustomerRankChart data={customerRankData} height={numberOfCustomer === "10" ? 800 : (numberOfCustomer === "20" ? 1200 : 3800)} />
                </div>
            </div>
           
            

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}